export default {
  institution: 'Institución',
  configurationAndInstitutionalData: 'Configuración y datos institucionales',
  changeLogo: 'Cambiar Logo',
  uploadLogo: 'Subir Logo',
  gradingSystem: 'Sistema de Calificaciones',
  gradesAndEvaluationsConfiguration: 'Configuración de notas y evaluaciones',
  minGrade: 'Nota Mínima',
  passingGrade: 'Nota Aprobatoria',
  maxGrade: 'Nota Máxima',
  exigencePercentage: 'Porcentaje de Exigencia',
  gradeLockedMessage: 'Actualmente la {gradeType} se encuentra bloqueada, comuníquese con un Administrador',
  mustBeGreaterThanOrEqualToZero: 'Debe ser mayor o igual a cero',
  cannotBeGreaterThanOrEqualToPassingGrade: 'No puede ser mayor o igual que la Nota Aprobatoria',
  cannotBeGreaterThanMaxGrade: 'No puede ser mayor que la Nota Máxima',
  cannotBeLessThanPassingGrade: 'No puede ser menor que la Nota Aprobatoria',
  cannotBeLessThanMinGrade: 'No puede ser menor que la Nota Mínima',
  exigencePercentageTooltip: 'Porcentaje de exigencia necesario para que una Evaluación se califique con la nota aprobatoria',
  mustBeBetweenZeroAndHundred: 'Debe ser mayor o igual a 0 y menor o igual a 100',
  academicSystem: 'Sistema Académico',
  creditsAndSchedulesConfiguration: 'Configuración de créditos y horarios',
  hoursPerSCTCredit: 'Horas por Crédito SCT',
  hoursPerCreditTooltip: 'Valor por el que se divide Total de Horas Pedagógicas para determinar la cantidad de Crédito SCT',
  minutesPerPedagogicalHour: 'Minutos por Hora Pedagógica',
  minutesPerHourTooltip: 'Valor utilizado para la conversión de horas pedagógicas a cronológicas en las Asignaturas que no cuenten con un Perfil de Egreso asociado',
  mustBeGreaterThanOrEqualToOne: 'Debe ser mayor o igual a 1',
  saveChanges: 'Guardar Cambios',
  selectImage: 'Seleccionar Imagen',
  institutionUpdated: 'Institución Actualizada',
  institutionLogoDeleted: 'Se Eliminó el Logo de la Institución',
  institutionLogoUpdated: 'Se Actualizó el Logo de la Institución',
}
